import { render, staticRenderFns } from "./InboundReports.vue?vue&type=template&id=7fa96433&"
import script from "./InboundReports.vue?vue&type=script&lang=js&"
export * from "./InboundReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports